import { render } from "./PropertyValuesModal.vue?vue&type=template&id=5d8c593d&scoped=true"
import script from "./PropertyValuesModal.vue?vue&type=script&lang=js"
export * from "./PropertyValuesModal.vue?vue&type=script&lang=js"

import "./PropertyValuesModal.vue?vue&type=style&index=0&id=5d8c593d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d8c593d"

export default script